define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"dojo/_base/event",
	"dojo/_base/lang",
	"dojo/keys",
	"dijit/DropDownMenu",
	"dijit/MenuItem",
	"dijit/MenuSeparator",
	"dijit/form/DropDownButton",
	"dijit/popup",
	"csi/_base/underscore",
	"csi/html",
	"./_HasDropDownMixin"
], function(array,declare,event,lang,keys,DropDownMenu,MenuItem,MenuSeparator,DropDownButton,popup,_,html,_HasDropDownMixin) {

	return declare([DropDownButton,_HasDropDownMixin], {
		// Action[]: actions to present in select control
		actions: null,

		// Boolean: flag to open drop-down menu on mouse-over
		//bOpenOnHover: false,

		// Boolean: flag to toggleopen/close dropdown on button mouse click
		bToggleOpen: false,
		
		// Function: extension point for triggering action
		onAction: function(/*Action*/a) {},

		// Function: extension point for passing through widget with tab/enter
		onNext: function(/*Number*/key, /*Boolean*/bShift) {},

		// Object: timer controlling automatic hiding of menu
		//_hideTimer: null,

		postCreate: function() {
			this.inherited(arguments);

			this._privateNodes = _.pluck(this.actions, "privateNode");
			
			if (this.bOpenOnHover) {
				this.connect(this, "onMouseEnter", this._showMenu);
				this.connect(this, "onMouseLeave", this._hideMenu);
			}
		},

		loadAndOpenDropDown: function() {
			// summary: create menu of available actions
			if (!this.dropDown) {
				this.dropDown = new DropDownMenu();
	
				array.forEach(this.actions, function(a, i) {
					if (a.separator){
						this.dropDown.addChild(new MenuSeparator());
					} else {
						var bToggled = false;
						var param = a;
						var privateNode = this._privateNodes[i];
						if (privateNode){
							param = privateNode;
							bToggled = a.isToggled(privateNode);
						}
						var params = {
							label: a.getMenuItemLabel(bToggled),
							onClick: lang.hitch(this, this._onAction, param)
						};
						params[html.getDataAttributeName(html.DATA_ACTION)] = a.m_id;
		
						this.dropDown.addChild(new MenuItem(params));
					}
				}, this);
	
				if (this.bOpenOnHover) {
					this.connect(this.dropDown, "onMouseEnter", this._showMenu);
					this.connect(this.dropDown, "onMouseLeave", this._hideMenu);
				}
			}
			
			return this.inherited(arguments);
		},

		_onDropDownMouseDown: function(/*Event*/e) {
			// summary: unless specified with bToggleOpen, don't close drop down when clicking on it - will confuse users who are used to clicking to show menu
			if (this.bToggleOpen || !this._opened) {
				this.inherited(arguments);
			}
		},

		_hideMenu: function() {
			// summary: hide drop down on mouse leave after brief timeout
			var self = this;

			if (this._opened && !this._hideTimer) {
				this._hideTimer = setTimeout(function() {
					self._hideTimer = null;

					if (self._opened) {
						self.toggleDropDown();

						// focus on menu to remove focus on any items so that next time menu is used
						// the previously selected item is not focused
						self.focus();
					}
				}, 250);
			}
		},

		_showMenu: function() {
			// summary: show drop down on mouse over so long as there is not already another popup on the screen
			if (this._hideTimer) {
				clearTimeout(this._hideTimer);
				this._hideTimer = null;
			}

			if (!this._opened && !popup.getTopPopup()) {
				this.toggleDropDown();
			}
		},

		_onAction: function(/*Action|DomNode*/a) {
			// summary: close drop down and invoke action
			// Here are some confusion about this function: sometimes argument is Action and sometimes it is DomNode
			// this is because it is calling user defined "onAction" which has independent logic and then it is ok, because user
			// defined "onAction" in some cases expects DomNode and in another cases Action.
			this.onAction(a);
		},

		_onKey: function(/*Event*/e) {
			// summary: support table keyboard navigation rather than normal events
			if ((e.keyCode == keys.ENTER) || (e.keyCode == keys.TAB)) {
				this.onNext(e.keyCode, e.shiftKey);
				event.stop(e);
			} else {
				this.inherited(arguments);
			}
		}
	});
});